import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import fetchesPublicChannelNotes from '../../../datasync/fetchesPublicChannelNotes'

import { selectors as PublicUISelectors } from 'data/publicUI'

class Loader extends Component {
  static propTypes = {
    channelId: PropTypes.string.isRequired,
    parentNoteId: PropTypes.string,
  }

  componentDidMount() {
    this.fetchFirstPage()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listState.name !== this.props.listState.name) {
      this.fetchFirstPage()
    } else {
      this.fetchNextPage()
    }
  }

  fetchFirstPage() {
    if (this.props.hasError) {
      return
    }
    this.props.fetchNextPage({ startFresh: true })
  }

  fetchNextPage() {
    if (
      !this.props.isLoading &&
      !this.props.hasError &&
      this.props.hasMore &&
      this.props.isVisible
    ) {
      this.props.fetchNextPage()
    }
  }

  render() {
    return false
  }
}

const mapStateToProps = (state, { listState, noteId }) => {
  const activeNoteId = PublicUISelectors.getActiveNoteId(state)
  return {
    isLoading: listState.loading,
    hasLoadedOnce: !listState.pristine,
    hasMore: listState.pageInfo.hasNextPage,
    hasError: Boolean(listState.error),
    hasNotes: listState.nodes.length > 0,
    isActiveParentNote: activeNoteId === noteId,
  }
}

export default compose(
  fetchesPublicChannelNotes({
    itemsPerPage: 25,
  }),
  connect(mapStateToProps)
)(Loader)
